<template>
  <el-container class="modelOne">
    <!-- <el-header height="70px">
      <home-header :logo="logo" :opacity="opacity"></home-header>
    </el-header>-->
    <el-main>
      <div class="bdContainer">
        <div class="container">
          <div style="margin:10px 0px">
            <search-andselect></search-andselect>
          </div>
          <div class="mainTop">
            <classify-nav :label="titles"></classify-nav>
            <div class="slideShow">
              <div class="left pic1">
                <el-carousel trigger="click" height="442px">
                  <el-carousel-item
                    v-for="(item, index) in banner.list"
                    :key="index"
                  >
                    <a class="bannerLink" :href="item.link_url">
                      <img :src="item.photo1" alt />

                      <p
                        v-text="
                          isGaonS
                            ? isEnglish &&
                              (item.title || '').indexOf('*##*') != -1
                              ? (item.title || '').split('*##*')[1]
                              : (item.title || '').split('*##*')[0]
                            : item.title
                        "
                        :title="
                          isGaonS
                            ? isEnglish &&
                              (item.title || '').indexOf('*##*') != -1
                              ? (item.title || '').split('*##*')[1]
                              : (item.title || '').split('*##*')[0]
                            : item.title
                        "
                      ></p>
                    </a>
                  </el-carousel-item>
                </el-carousel>
              </div>
              <div class="right">
                <a :href="hot.list[0].link_url">
                  <div class="top">
                    <img :src="hot.list[0].photo1" alt />

                    <div
                      class="imgtitle"
                      :title="
                        isGaonS
                          ? isEnglish &&
                            (hot.list[0].title || '').indexOf('*##*') != -1
                            ? (hot.list[0].title || '').split('*##*')[1]
                            : (hot.list[0].title || '').split('*##*')[0]
                          : hot.list[0].title
                      "
                    >
                      {{
                        isGaonS
                          ? isEnglish &&
                            (hot.list[0].title || "").indexOf("*##*") != -1
                            ? (hot.list[0].title || "").split("*##*")[1]
                            : (hot.list[0].title || "").split("*##*")[0]
                          : hot.list[0].title
                      }}
                    </div>
                  </div>
                </a>
                <a :href="hot.list[1].link_url">
                  <div class="bottom">
                    <img :src="hot.list[1] ? hot.list[1].photo1 : ''" alt />
                    <div
                      class="imgtitle"
                      :title="
                        isGaonS
                          ? isEnglish &&
                            (hot.list[1].title || '').indexOf('*##*') != -1
                            ? (hot.list[1].title || '').split('*##*')[1]
                            : (hot.list[1].title || '').split('*##*')[0]
                          : hot.list[1].title
                      "
                    >
                      {{
                        isGaonS
                          ? isEnglish &&
                            (hot.list[1].title || "").indexOf("*##*") != -1
                            ? (hot.list[1].title || "").split("*##*")[1]
                            : (hot.list[1].title || "").split("*##*")[0]
                          : hot.list[1].title
                      }}
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="mainBottom">
          <new-roll ref="new_roll" :label="label"></new-roll>
        </div>
      </div>
    </el-main>
    <el-footer
      v-if="hidefooter"
      :style="{ height: webID == '111142' ? '120px' : '316px' }"
    >
      <help-footer v-if="webID == 111142"></help-footer>
      <home-footer v-else></home-footer>
    </el-footer>
  </el-container>
</template>

<script>
import searchAndselect from "../components/searchAndselect.vue";
import homeFooterAd from "../components/homeFooterAd.vue"; //底部
import homeHeader from "../components/homeHeader.vue"; //顶部
import homeFooter from "../components/homeFooter.vue"; //底部
import classifyNav from "../components/classifyNav.vue"; //全部分类
import newRoll from "../components/newRoll.vue"; //最新滚动
import adsearch from "../components/adSearch.vue"; //广告
import helpFooter from "../components/helpFooter.vue"; //底部

import { mapActions, mapGetters } from "vuex";
import {
  getModuleInfo,
  newtitle,
  newtitle1,
  getResource,
  getCategoryNode
} from "./../services/api.js";
export default {
  name: "modelOne",
  components: {
    adsearch
  },
  data() {
    return {
      opacity: "0.68",
      label: {
        id: "",
        list: [{ photo1: "", title: "" }]
      },
      titles: {
        id: "",
        list: [{ photo1: "", title: "" }]
      },
      banner: {
        id: "",
        list: [{ photo1: "", title: "" }]
      },
      hot: {
        id: "",
        list: [
          { photo1: "", title: "" },
          { photo1: "", title: "" }
        ]
      },
      logo: {
        id: "",
        list: [{ photo1: "" }]
      }
    };
  },
  computed: {
    ...mapGetters([
      "modelsInfo",
      "curModelInfo",
      "webModels",
      "webID",
      "hidefooter",
      "isGaonS",
      "isEnglish"
    ]),
    channel_id() {
      return this.curModelInfo.id;
      //return this.modelsInfo.filter(item => item.tpl_id == 2)[0].id;
    }
  },
  watch: {
    channel_id() {
      this.getModuleInfo();
    }
  },
  mounted() {
    this.getModuleInfo();
    // window.addEventListener("scroll", this.mosewheel, true);
  },
  methods: {
    async getHotsDataByCategoryChangeV(item) {
      var obj = {
        review_state: 1 + "",
        search_type: 2 + "",
        // online_state: 1 + "",
        customer_id: this.webid,
        group_id: item.body9
      };
      if (item.body10 == "1") {
        let resul = await getResource(obj, 2);
        return {
          photo1: resul.data
            ? this.getSpecialShowImgUrl(resul.data.data[0])
            : "",
          link_url: `/search?isEnglish=false&type=1&text=&group_id=${item.body9}`,
          title: resul.data ? resul.data.data[0].group_title : ""
        };
      } else if (item.body10 == "2") {
        let resul = await getCategoryNode({
          customer_id: this.webid,
          category_id: item.body9
        });
        return {
          photo1: resul.data
            ? this.getSpecialShowImgUrl_Category(resul.data[0])
            : "",
          link_url: `/intopic?category=${item.body9}&text=${
            resul.data ? resul.data[0].cname : ""
          }&bigimg=${resul.data ? resul.data[0].index_image : ""}`,
          title: resul.data ? resul.data[0].cname : ""
        };
      } else if (item.body10 == "3") {
        return {
          photo1: item.promotion_cover,
          link_url: `/spread?promotion=${item.promotion_pic}`,
          title: "推广页"
        };
      }
    },
    async getGroupsDataByCategoryChangeV(item) {
      var obj = {
        review_state: 1 + "",
        search_type: 2 + "",
        // online_state: 1 + "",
        customer_id: this.webid,
        group_id: item.body9
      };
      if (item.body10 == "1") {
        let resul = await getResource(obj, 2);
        return {
          photo1: resul.data
            ? this.getCarouselShowImgUrl(resul.data.data[0])
            : "",
          link_url: `/search?isEnglish=false&type=1&text=&group_id=${item.body9}`,
          title: resul.data ? resul.data.data[0].group_title : ""
        };
      } else if (item.body10 == "2") {
        let resul = await getCategoryNode({
          customer_id: this.webid,
          category_id: item.body9
        });
        return {
          photo1: resul.data
            ? this.getCarouselShowImgUrl_Category(resul.data[0])
            : "",
          link_url: `/intopic?category=${item.body9}&text=${
            resul.data ? resul.data[0].cname : ""
          }&bigimg=${resul.data ? resul.data[0].index_image : ""}`,
          title: resul.data ? resul.data[0].cname : ""
        };
      } else if (item.body10 == "3") {
        return {
          photo1: item.promotion_cover,
          link_url: `/spread?promotion=${item.promotion_pic}`,
          title: "推广页"
        };
      }
    },
    getSpecialShowImgUrl_Category(item) {
      if (item.custom_index_image) {
        if (item.custom_index_image["1200x600"]) {
          return item.custom_index_image["1200x600"];
        }
      }
      return item.index_image;
    },
    getSpecialShowImgUrl(item) {
      if (item.group_custom_index_image) {
        if (item.group_custom_index_image["1200x600"]) {
          return item.group_custom_index_image["1200x600"];
        }
      }
      return item.group_index_image;
    },
    getCarouselShowImgUrl_Category(item) {
      if (item.custom_index_image) {
        if (item.custom_index_image["1200x950"]) {
          return item.custom_index_image["1200x950"];
        }
      }
      return item.index_image;
    },
    getCarouselShowImgUrl(item) {
      if (item.group_custom_index_image) {
        if (item.group_custom_index_image["1200x950"]) {
          return item.group_custom_index_image["1200x950"];
        }
      }
      return item.group_index_image;
    },
    getGroupsDataByCategory(id, num) {
      var obj = {
        review_state: 1 + "",
        category_view: id,
        search_type: 2 + "",
        // online_state: 1 + "",
        customer_id: this.webID
      };
      getResource(obj, 2).then(res => {
        this.banner = {
          id: this.banner.id,
          list: res.data.data
        };
        this.banner.list.forEach(item => {
          item[
            "link_url"
          ] = `/search?isEnglish=false&type=1&text=&group_id=${item.group_id}`;
          item["showImg_url"] = this.getCarouselShowImgUrl(item);
        });
        this.banner.list = this.banner.list.splice(0, num);
      });
    },
    mosewheel(event) {
      let scrolltop =
        document.body.scrollTop ||
        document.documentElement.scrollTop ||
        window.pageYOffset;
      if (scrolltop == 0) {
        this.opacity = "0.68";
      } else {
        this.opacity = "1";
      }
    },
    intoDetail(item) {
      // 跳往大图
      let routeData = this.$router.resolve({
        path: "/detail",
        query: {
          asset: item.asset_id,
          group: item.group_id,
          index: index,
          webid: this.webID
        }
      });
      window.open(routeData.href, "_blank");
      // let routeData = this.$router.resolve({ path: "/detail", query: { group: item.group_id}});
      // window.open(routeData.href, "_blank");
    },
    intoSpecial(item) {
      // 跳往大图
      // this.$router.push({
      //   path: "/intopic",
      //   query: { asset: item.asset_id, group: item.group_id }
      // });

      this.$router.push({
        path: "/search"
        // query: {
        //   type: 0,
        //   text: "",
        //   group_id: item.body9
        // }
      });
    },
    getModuleInfo() {
      console.log(this.$store.getters);
      var id = setInterval(() => {
        if (this.$store.getters.webModels.module_data) {
          clearInterval(id);
          var label = this.webModels.module_data.find(item => {
            if (item.title == "标签") return item;
          });
          var banner = this.webModels.module_data.find(item => {
            if (item.title == "A轮播图") return item;
          });
          var hot = this.webModels.module_data.find(item => {
            if (item.title == "A热门专题") return item;
          });
          var logo = this.webModels.module_data.find(item => {
            if (item.title == "logo") return item;
          });
          var homeColor = this.webModels.module_data.find(item => {
            if (item.title == "首页底色") return item;
          });
          let data = {
            module_id: logo.id,
            web_id: this.webID,
            use_sort_num: 1,
            channel_id: this.channel_id //this.curModelInfo.id
          };
          getModuleInfo(data, {
            page: 1,
            page_nums: logo.rows_num
          }).then(res => {
            if (res.status_code == 1) {
              this.logo = {
                id: logo.id,
                list: res.data.list
              };
            }
          });

          data.module_id = label.id;
          let totallist = [];
          newtitle({
            params: {
              customer_id: this.webID
            }
          }).then(res => {
            if (res) {
              if (res.status_code == 1) {
                var lis = res.data.list.filter(item => {
                  return item.level == 1 && item.active == 1;
                });
                lis.forEach(item => {
                  totallist.push({
                    id: item.id,
                    cname: item.cname,
                    type: item.type
                  });
                });
                newtitle1({
                  params: {
                    customer_id: this.webID
                  }
                }).then(res => {
                  if (res) {
                    if (res.status_code == 1) {
                      var lis = res.data.list.filter(item => {
                        return item.level == 1 && item.active == 1;
                      });
                      lis.forEach(item => {
                        totallist.push({
                          id: item.id,
                          cname: item.cname,
                          type: item.type
                        });
                      });
                      this.titles = {
                        id: 1,
                        list: totallist
                      };
                    }
                  }
                });
              }
            }
          });
          getModuleInfo(data, {
            page: 1,
            // page_nums: label.rows_num,
            sort: "asc"
          }).then(res => {
            if (res.status_code == 1) {
              this.label = {
                id: label.id,
                list: res.data.list
              };
            }
          });
          data.module_id = banner.id;
          getModuleInfo(data, {
            page: 1,
            page_nums: banner.rows_num
          }).then(async res => {
            if (res.status_code == 1) {
              this.banner = {
                id: banner.id,
                list: res.data.list
              };
              for (let i = 0; i < this.banner.list.length; i++) {
                let resul = await this.getGroupsDataByCategoryChangeV(
                  this.banner.list[i]
                );
                this.banner.list[i].photo1 = resul.photo1;
                this.banner.list[i].link_url = resul.link_url;
                this.banner.list[i].title = resul.title;
                this.$set(this.banner.list, i, this.banner.list[i]);
              }
            }
          });
          data.module_id = hot.id;
          getModuleInfo(data, {
            page: 1,
            page_nums: hot.rows_num
          }).then(async res => {
            if (res.status_code == 1) {
              this.hot = {
                id: this.hot.id,
                list: res.data.list
              };
              for (let i = 0; i < this.hot.list.length; i++) {
                let resul = await this.getHotsDataByCategoryChangeV(
                  this.hot.list[i]
                );
                this.hot.list[i].photo1 = resul.photo1;
                this.hot.list[i].link_url = resul.link_url;
                this.hot.list[i].title = resul.title;
                this.$set(this.hot.list, i, this.hot.list[i]);
              }
            }
          });
          data.module_id = homeColor.id;
          getModuleInfo(data, {
            page: 1,
            page_nums: logo.rows_num
          }).then(res => {
            if (res.status_code == 1) {
              this.homeColor = {
                id: homeColor.id,
                list: res.data.list
              };
              var bgColor = this.homeColor.list[0].body;
              if (bgColor) {
                bgColor = bgColor.slice(1, 7);
                bgColor = bgColor.split("");
                var oXColor = [];
                for (let i = 0; i < 3; i++) {
                  oXColor.unshift(
                    parseInt(bgColor[i * 2] + bgColor[i * 2 + 1], 16)
                  );
                }
                this.homeColor.list[0].body = "rgba(" + oXColor.join(",") + ")";
              }
            }
          });
        }
      }, 0);
    }
  },
  components: {
    homeHeader,
    homeFooter,
    classifyNav,
    newRoll,
    adsearch,
    homeFooterAd,
    searchAndselect,
    helpFooter
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.modelOne {
  .el-footer {
    padding: 0px;
  }
  .el-main {
    .mainTop {
      .slideShow {
        .left {
          .el-carousel__indicators {
            left: auto;
            right: 0;
            height: 56px;
            display: flex;
            align-items: center;
            .el-carousel__indicator {
              .el-carousel__button {
                width: 10px;
                height: 10px;
                border-radius: 50%;
              }
            }
          }
          .el-carousel__item {
            .bannerLink {
              display: block;
              width: 100%;
              height: 100%;
              position: relative;
              img {
                width: 100%;
                height: 100%;
              }
              p {
                position: absolute;
                width: 100%;
                background-color: rgba(0, 0, 0, 0.5);
                left: 0;
                bottom: 0;
                height: 56px;
                font-size: 14px;
                font-family: PingFangSC-Regular;
                color: rgba(255, 255, 255, 1);
                line-height: 56px;
                padding: 0px 0px 18px 23px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
          }
        }
      }
    }
  }
  .el-header {
    padding: 0px;
    .homeHeader {
      background-color: #fff;
    }
  }
  .bdContainer {
    width: 100%;
    background-color: #f7f7f7;
    padding-top: 10px;
  }
  .el-main {
    overflow: hidden;
    margin-top: 0px;
    padding: 0;
    .mainTop {
      width: 100%;
      height: 442px;
      background-color: #f7f7f7;
      // padding: 31px 0 33px 0;
      display: flex;
      .slideShow {
        width: 1008px;
        height: 100%;
        // background-color:purple;
        display: flex;
        .left {
          width: 660px;
          height: 100%;
          /*background-color: rgb(23, 138, 103);*/
          margin-right: 10px;
          position: relative;
          .el-carousel__indicators {
            left: auto;
            right: 0;
            height: 56px;
            display: flex;
            align-items: center;
            .el-carousel__indicator {
              .el-carousel__button {
                width: 10px;
                height: 10px;
                border-radius: 50%;
              }
            }
          }
        }
        .right {
          width: 436px;
          height: 100%;
          flex: 1 1 auto;
          & > div {
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .top,
          .bottom {
            position: relative;
            cursor: pointer;
            height: 216px;
            width: 100%;
            img {
              width: 100%;
              height: 100%;
            }
            .imgtitle {
              position: absolute;
              bottom: 0px;
              left: 0px;
              background-color: rgba(0, 0, 0, 0.5);
              height: 42px;
              width: 100%;
              line-height: 42px;
              color: white;
              box-sizing: border-box;
              padding-left: 15px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
          .top {
            box-sizing: border-box;
            margin-bottom: 10px;
            img {
              max-width: 100%;
              max-height: 100%;
            }
          }
        }
      }
    }
    .mainBottom {
      width: 100%;
      overflow: hidden;
      padding: 30px 0px;
    }
  }
  .el-footer {
    background-color: #181a1a;
    position: relative;
  }
  .bgContainer {
    background-color: #f7f7f7;
  }
  .container {
    width: 1200px;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/modelOne.vue